import { render, staticRenderFns } from "./EditarContrato.vue?vue&type=template&id=631f4d6d&scoped=true&"
import script from "./EditarContrato.vue?vue&type=script&lang=js&"
export * from "./EditarContrato.vue?vue&type=script&lang=js&"
import style0 from "./EditarContrato.vue?vue&type=style&index=0&id=631f4d6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f4d6d",
  null
  
)

component.options.__file = "EditarContrato.vue"
export default component.exports